import React from 'react';
import './PageTitle.scss';

const PageTitle = ({ children }) => {
  return <h2 className='page-title'>{children}</h2>;
};

export default PageTitle;
